<template>
  <div>
    <NavigationBar
      titel="Zielvorgabe bearbeiten"
      showBackBtn
      :actions="actions"
    ></NavigationBar>
    <section>
      <v-form
        @submit.prevent="updateItem"
        ref="form"
        v-model="helpers.formIsValid"
      >
        <performance-target-editor
          v-model="performanceTarget"
          mode="edit"
        ></performance-target-editor>
      </v-form>
    </section>
  </div>
</template>

<script>
import { db, Timestamp } from "@/firebase";
import { MEMBER_MANAGEMENT } from "@/store/modules.js";
import { UPDATE_PERFORMANCE_TARGET } from "@/store/action-types.js";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import PerformanceTargetEditor from "@/components/member-management/performance-targets/PerformanceTargetEditor.vue";

export default {
  name: "member-management-performance-targets-edit",
  components: {
    NavigationBar,
    PerformanceTargetEditor,
  },
  data() {
    return {
      actions: [
        {
          title: "Speichern",
          icon: "mdi-content-save",
          actionStyle: "textBtnSubmit",
          function: this.updateItem,
        },
      ],
      performanceTarget: null,

      helpers: {
        formIsValid: false,
      },
    };
  },
  computed: {},
  created() {
    this.initialize();
  },
  watch: {
    $route: "initialize",
  },
  methods: {
    initialize() {
      db.collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("performanceTargets")
        .doc(this.$route.params.itemId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.performanceTarget = doc.data();
            (this.performanceTarget.validFrom.date = this.convertToDate(
              this.performanceTarget.validFrom.timestamp
            )),
              (this.performanceTarget.validFrom.time = this.convertToTime(
                this.performanceTarget.validFrom.timestamp
              )),
              (this.performanceTarget.validUntil.date = this.convertToDate(
                this.performanceTarget.validUntil.timestamp
              )),
              (this.performanceTarget.validUntil.time = this.convertToTime(
                this.performanceTarget.validUntil.timestamp
              ));
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
          return false;
        });
    },
    convertToDate(date) {
      date = date.toDate();
      return (
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1 < 10 ? "0" : "") +
        (date.getMonth() + 1) +
        "-" +
        (date.getDate() < 10 ? "0" : "") +
        date.getDate()
      );
    },
    convertToTime(time) {
      time = time.toDate();
      return (
        (time.getHours() < 10 ? "0" : "") +
        time.getHours() +
        ":" +
        (time.getMinutes() < 10 ? "0" : "") +
        time.getMinutes()
      );
    },
    validate() {
      this.$refs.form.validate();
    },
    updateItem() {
      this.validate();

      if (this.helpers.formIsValid) {
        var res = confirm(
          "Bist Du sicher, dass Du die Zielvorgabe aktualisieren möchtest. Bevorstehende Berechnungen werden mit der angepassten Version vorgenommen. Alte Berechnungen werden nicht aktualisiert, sofern keine manuelle Anforderung erfolgt. Soll die Änderung erst zu einem bestimmten Zeitpunkt erfolgen, wird empfohlen bis zu diesem Zeitpunkt abzuwarten und dann eine manuelle Neuberechnung durchzuführen.\n\nSoll die Aktualisierung trotzdem ausgeführt werden?"
        );
        if (res == true) {
          this.$store.dispatch(
            `${MEMBER_MANAGEMENT}${UPDATE_PERFORMANCE_TARGET}`,
            {
              organizationId: this.$route.params.organizationId,
              itemId: this.$route.params.itemId,

              title: this.performanceTarget.title,
              shortTitle: this.performanceTarget.shortTitle,
              sortKey: this.performanceTarget.sortKey,
              isActive: this.performanceTarget.isActive,
              requiredForLevel: this.performanceTarget.requiredForLevel || null,
              validFrom: {
                timestamp: this.convertToTimestamp(
                  this.performanceTarget.validFrom.date,
                  this.performanceTarget.validFrom.time
                ),
              },
              validUntil: {
                timestamp: this.convertToTimestamp(
                  this.performanceTarget.validUntil.date,
                  this.performanceTarget.validUntil.time
                ),
              },
              applicableDivisionIds:
                this.performanceTarget.applicableDivisionIds,
              monitoringInterval: {
                unit: this.performanceTarget.monitoringInterval.unit,
                value: this.performanceTarget.monitoringInterval.value,
              },
              dataVariables: this.performanceTarget.dataVariables,
              primaryDataVariable: this.performanceTarget.primaryDataVariable,
              targetValue: this.performanceTarget.targetValue,
              conditions: {
                logicalOperator:
                  this.performanceTarget.conditions.logicalOperator,
                conditions: this.performanceTarget.conditions.conditions,
              },
            }
          );
        }
      } else {
        alert("Prüfe Deine Eingabe und versuche es erneut.");
      }
    },
    convertToTimestamp(date, time) {
      const input = date + " " + time;
      return Timestamp.fromDate(new Date(input.replace(/-/g, "/")));
    },
  },
};
</script>
